import React from 'react';
import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import Button from '@/components/common/Button';
import { useLayoutContext } from '@/context/LayoutContext';
import { TRIGGERS } from '@/api/global';

export default function ReserveButton({
  item,
  text = 'رزرو نوبت',
  className = '',
  type = 'service',
  fill = 'var(--paper)',
}: {
  item?: any;
  text?: string;
  className?: string;
  type?: 'service' | 'shop';
  fill?: string;
}) {
  const { setTrigger, setEditInfo } = useLayoutContext();
  return (
    <Button
      className={`btn btn-primary squareButton ${styles.button} ${className}`}
      onClick={() => {
        if (item) {
          setTrigger(TRIGGERS.RESERVE_SERVICE);
          setEditInfo({ item, level: type == 'shop' ? 1 : 2, type: type });
        }
      }}
    >
      <MainIcons.CalendarIcon fill={fill} width="18px" height="18px" />
      {text}
    </Button>
  );
}
